import InternalInput from './input';
import TextArea from './textArea';
import type { InputProps, InputRef } from './input';
import type { TextAreaProps } from './textArea';

type CompoundedComponent = React.ForwardRefExoticComponent<
  InputProps & React.RefAttributes<InputRef>
> & {
  TextArea: typeof TextArea;
};

const Input = InternalInput as CompoundedComponent;
Input.TextArea = TextArea;

export type { InputProps, InputRef, TextAreaProps };
export default Input;

